<template>
  <div>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-row>
      <b-col>
        <md-card>
          <md-button class="md-icon-button md-dense" @click="close()">
            <md-icon>highlight_off</md-icon>
          </md-button>
          <md-card-header style="text-align: center" class="mt-3 mb-3">
            <b-row>
              <b-col>
                <div v-if="showLoginForm">
                  <span class="moow-header large center">Log in</span>
                  <p class="mt-3">
                    Don't have account?
                    <a class="clickable" @click="showLoginForm = false"
                      >Sign up here</a
                    >
                  </p>
                </div>
                <div v-else>
                  <span class="moow-header large center">Sign up</span>
                  <p class="mt-3">
                    Already have an account?
                    <a class="clickable" @click="showLoginForm = true"
                      >Log in here</a
                    >
                  </p>
                </div>
              </b-col>
            </b-row>
          </md-card-header>

          <md-card-content>
            <login-form
              v-if="showLoginForm"
              @emitSuccessfulLogin="successfulOperation"
              @emitFailedLogin="failedOperation"
              @emitLoading="toggleLoading"
            ></login-form>
            <register-form
              v-else
              :userRole="userRole"
              @emitSuccessfulRegistration="successfulOperation"
              @emitFailedRegistration="failedOperation"
              @emitLoading="toggleLoading"
            ></register-form>
          </md-card-content>
        </md-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import LoginForm from "./loginForm.vue";
import RegisterForm from "./registerForm.vue";
export default {
  name: "Login",
  props: {
    userRole: {
      type: String,
      required: false
    }
  },
  components: {
    "login-form": LoginForm,
    "register-form": RegisterForm,
  },
  data() {
    return {
      loading: false,
      showLoginForm: false,
    };
  },
  watch: {},
  methods: {
    close() {
      this.$emit("emitClose");
    },
    toggleLoading(value) {
      this.loading = value;
    },
    successfulOperation() {
      this.toggleLoading(false);
      sessionStorage.setItem("signedIn", true);
      this.$emit("emitProcessFinished", true);
    },
    failedOperation(error) {
      this.toggleLoading(false);
      this.$emit("emitProcessFinished", false);
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
.underlined {
  color: #f2b1d8;
}
.form-container {
  overflow-y: scroll;
  height: 100%;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/DialogLoginRegister.vue